var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":"lg"}},[_c('div',{staticClass:"pricing my-5"},[_c('pricing-header'),_c('pricing-section')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }